/* istanbul ignore file */
import React from 'react';
import { NextPageContext } from 'next';
import logger from '@lib/logger';
import ErrorPage, { IErrorProps } from '@components/pages/Error/Error';
import ThemeProvider from '@components/theme/ThemeProvider';

function Error(props: IErrorProps) {
  return (
    <ThemeProvider>
      <ErrorPage {...props} />
    </ThemeProvider>
  );
}

Error.getInitialProps = ({ err, res }: NextPageContext) => {
  const statusCode = res?.statusCode || err?.statusCode || 500;
  logger().error({ err, statusCode }, 'Internal error');
  return {
    message: (res && process.env.NODE_ENV !== 'production' && err?.message) || '',
    statusCode
  };
};

export default Error;
